<ng-container *ngIf="isLoading;else pageContent">
	<div class="app-spinner">
	<mat-spinner></mat-spinner>
	</div>
</ng-container>
	
<ng-template #pageContent>
<div class="course-header">
  <div class="top-row">
	<img src="assets/images/arrow_left_alt.svg" (click)="goBack()">
    <div class="tag-container justify-content-start">
      <span class="tag">{{ _classroomName || (_quizService.className | async) }}</span>
      <span class="separator">•</span>
      <span class="sub-tag">{{ _subjectName ||  (_quizService.subjectName | async) }}</span>
  </div>
  <div class="text-end d-flex align-items-center gap-1 ms-auto"  *ngIf="quizStatus === CourseStatusEnum.Draft">
  <div class="draft-status"><i class="bi bi-check2-circle"></i> Drafted
  </div>
    </div>
  </div>
  <h2 class="quiz-title">{{ _quizName || (_quizService.quizName | async) }} 
	<i class="bi bi-pencil" *ngIf="quizId && quizStatus !== CourseStatusEnum.Published"
    (click)="openEditTitleBox(false)"></i>
</h2>
  <div class="text-end">Time Limit
		<span class="quiztime ms-2"> {{ formatTime(_quizTimeLimit)}}
           <i class="bi bi-pencil" *ngIf="quizId  && quizStatus !== CourseStatusEnum.Published" 
			(click)="openEditTitleBox(true)"></i>
 </span>
  </div>
</div>

<div class="quiz-section">
	<div class="d-flex justify-content-between align-item-center mb-1">
	<h3 *ngIf="_quizData">Quiz Questions ({{ _quizData.length || 0 }} Questions) </h3>
    <ng-container *hasPermission="PermissionForStudents.QUIZ_CREATE">
	<button class="btn-add mt-0" (click)="goToQuizPage()"
  *ngIf="quizStatus === CourseStatusEnum.Draft">Add Questions</button>
	</ng-container>
  </div>
  <div cdkDropList (cdkDropListDropped)="drop($event)">

  <div  class="question-card"  *ngFor="let quizQuestion of _quizData; let i = index" cdkDrag
  [cdkDragDisabled]="quizStatus === CourseStatusEnum.Published">
    <div class="question-header">
	<img src="assets/images/drag.png" class="topic-icon" alt="drag-icon">
      <span class="question-number">Q{{ i + 1 }}</span>
      <span class="question-type">{{ quizQuestion.question_type }}</span>
      <span class="question-score">{{ quizQuestion.marks }} pt</span>
    </div>
    <p class="question-text">{{ quizQuestion.question_text }}</p>

	<ul class="options" *ngIf="quizQuestion.question_type === QuizQuestionType.TRUE_FALSE">
  <li [ngClass]="{ correct: ('' + quizQuestion.correct_answer).toLowerCase().trim() === 'true' }">A. True </li>
  <li [ngClass]="{ correct: ('' + quizQuestion.correct_answer).toLowerCase().trim() === 'false' }">B. False</li>
   </ul>

    <ul class="options" *ngIf="quizQuestion.question_type === QuizQuestionType.OPEN_ENDED">
      <p class="key-answer">Key Answer:</p>
      <div class="answer-box">{{ quizQuestion.correct_answer }}</div>
    </ul>

    <ul class="options" *ngIf="quizQuestion.question_type === QuizQuestionType.MCQ">
      <li *ngFor="let option of quizQuestion.options; let i = index"
    [ngClass]="{ correct: option.text?.toLowerCase() === quizQuestion.correct_answer.toLowerCase() }">
        {{ getOptionLabel(i) }}. {{ option.text }}
      </li>
    </ul>

    <div class="actions"> <img src="assets/images/edit.svg" alt="Edit" 	  
		*ngIf="quizStatus !== CourseStatusEnum.Published"
        class="edit-icon" (click)="editQuestion(quizQuestion)"/>

      <img src="assets/images/delete.svg" alt="Delete" class="delete-icon"
	  *ngIf="quizStatus !== CourseStatusEnum.Published"
	 (click)="openDeleteDialogBox(quizId , quizQuestion.question_id || '')" />
    </div>
  </div>
</div>
</div>
 
<div *ngIf="currentPopup === QuizQuestionType.MCQ" class="popup" (click)="closePopup($event)">
  <div (click)="$event.stopPropagation()">
    <h3>Edit Question</h3>
    <i class="bi bi-x close-icon" (click)="closePopup()"></i>

    <form [formGroup]="quizForm">
      <label>Question Text*</label>
      <textarea formControlName="question_text" placeholder="Add your question here..." class="question-textarea"></textarea>
      <small *ngIf="quizForm.get('question_text')?.invalid && (quizForm.get('question_text')?.touched || 
	  quizForm.get('question_text')?.dirty)" class="text-danger smaller-text"> Question is required.</small>
      <label>Answer Options</label>
      <div formArrayName="options" class="options-list">
        <div class="option-item" *ngFor="let opt of options.controls; let i = index" [formGroupName]="i">
        <input type="radio" [value]="i" [formControl]="correctAnswerFormControl"/>
          <input type="text" formControlName="text" placeholder="Option {{ i + 1 }}" />
          <input formControlName="order" type="hidden" />
        </div> 
      </div>
   
	  <small *ngIf="quizForm.get('options')?.hasError('noOptions') && (quizForm.get('options')?.touched || 
	  quizForm.get('options')?.dirty)"class="text-danger smaller-text"> At least one option is required.</small>

       <small *ngIf="quizForm.get('options')?.hasError('emptyOption') && (quizForm.get('options')?.touched || 
	   quizForm.get('options')?.dirty)" class="text-danger smaller-text"> Option text cannot be empty.</small>

	     <small *ngIf="quizForm.get('options')?.hasError('duplicateOptions') && (quizForm.get('options')?.touched 
	  || quizForm.get('options')?.dirty)" class="text-danger smaller-text">
        Duplicate options are not allowed. Please fix them before saving. </small>

      <label>Points</label>
      <input type="number" formControlName="marks" placeholder="e.g. 1" class="points-input" />
              
	  <small *ngIf="quizForm.get('marks')?.hasError('required') && (quizForm.get('marks')?.touched 
	  || quizForm.get('marks')?.dirty)" class="text-danger smaller-text"> Points are required.</small>

      <small *ngIf="quizForm.get('marks')?.hasError('min') &&  (quizForm.get('marks')?.touched 
	  || quizForm.get('marks')?.dirty)" class="text-danger smaller-text"> Points must be at least 1.</small>

      <div class="action-buttons">
        <button class="cancel" type="button" (click)="closePopup()">Cancel</button>
        <button class="save" type="button" (click)="updateQuizQuestion()" [disabled]="isUpdateDisabled">Save Changes</button>
      </div>
    </form>
  </div>
</div>


<div *ngIf="currentPopup === QuizQuestionType.TRUE_FALSE" class="popup" (click)="closePopup($event)">
  <div (click)="$event.stopPropagation()">
    <h3>Edit Question</h3>
    <i class="bi bi-x close-icon" (click)="closePopup()"></i>

    <form [formGroup]="quizForm">
      <label>Question Text*</label>
      <textarea formControlName="question_text" placeholder="Add your question here..." class="question-textarea"></textarea>
      <small *ngIf="quizForm.get('question_text')?.invalid && (quizForm.get('question_text')?.touched || 
	  quizForm.get('question_text')?.dirty)" class="text-danger smaller-text"> Question is required.</small>

      <label>Answer Options</label>
      <div class="radio-group">
        <label>
          <input type="radio" formControlName="correct_answer" value="true" /> True
        </label>
        <label>
          <input type="radio" formControlName="correct_answer" value="false" /> False
        </label>
      </div>

      <label>Points</label>
      <input type="number" formControlName="marks" placeholder="e.g. 1" class="points-input" />

	    <small *ngIf="quizForm.get('marks')?.hasError('required') && (quizForm.get('marks')?.touched 
	  || quizForm.get('marks')?.dirty)" class="text-danger smaller-text"> Points are required.</small>

      <small *ngIf="quizForm.get('marks')?.hasError('min') &&  (quizForm.get('marks')?.touched 
	  || quizForm.get('marks')?.dirty)" class="text-danger smaller-text"> Points must be at least 1.</small>


      <div class="action-buttons">
        <button class="cancel" type="button" (click)="closePopup()">Cancel</button>
        <button class="save" type="button" (click)="updateQuizQuestion()"
		 [disabled]=" (quizForm.invalid && quizForm.value.question_type === 'MCQ') ||
                      (quizForm.value.question_type === 'TRUE_FALSE' && !quizForm.value.correct_answer) ||
                      (quizForm.value.question_type === 'OPEN_ENDED' && !quizForm.value.key_answer)">Save Changes</button>
      </div>
    </form> 

  </div> 
</div> 

<div *ngIf="currentPopup === QuizQuestionType.OPEN_ENDED" class="popup" (click)="closePopup($event)">
    <div (click)="$event.stopPropagation()">
        <h3>Edit Question</h3>
        <i class="bi bi-x close-icon" (click)="closePopup()"></i>

		<form [formGroup]="quizForm">
        <label>Question Text*</label>
        <textarea formControlName="question_text" placeholder="Add your question here..." class="question-textarea"></textarea>
		<small *ngIf="quizForm.get('question_text')?.invalid && (quizForm.get('question_text')?.touched || 
	    quizForm.get('question_text')?.dirty)" class="text-danger smaller-text"> Question is required.</small>

        <label>Key Answer</label>
        <textarea formControlName="key_answer" placeholder="Add a reference answer to help with evaluating student responses accurately."></textarea>
		<small *ngIf="quizForm.get('key_answer')?.invalid && (quizForm.get('key_answer')?.touched || 
	    quizForm.get('key_answer')?.dirty)" class="text-danger smaller-text"> Answer is required.</small>

        <label>Points</label>
        <input type="number" formControlName="marks" placeholder="e.g. 1" class="points-input" />
		
	  <small *ngIf="quizForm.get('marks')?.hasError('required') && (quizForm.get('marks')?.touched 
	  || quizForm.get('marks')?.dirty)" class="text-danger smaller-text"> Points are required.</small>

      <small *ngIf="quizForm.get('marks')?.hasError('min') &&  (quizForm.get('marks')?.touched 
	  || quizForm.get('marks')?.dirty)" class="text-danger smaller-text"> Points must be at least 1.</small>

        <div class="action-buttons">
            <button class="cancel" (click)="closePopup()">Cancel</button>
            <button class="save" (click)="updateQuizQuestion()"
			  [disabled]="quizForm.get('question_text')?.invalid || quizForm.get('key_answer')?.invalid ||
			   quizForm.get('marks')?.invalid">Save Changes</button>
        </div>
	</form>
    </div>
</div>

<!-- footer -->
<div class="footer-bar" *ngIf="_quizData?.length">
  <div class="button-group">
   <button class="btn outline" (click)="openUnpublishDialogBox()" 
	[disabled]="isDraft" *ngIf="quizStatus === CourseStatusEnum.Published">
	<i class="bi bi-save"></i>
	<ng-container *ngIf="!isDraft; else noDraft">Unpublish Quiz</ng-container>
	<ng-template #noDraft>
		<span class="spinner-text">
			<mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>UnPublishing...
		</span>
	</ng-template>
</button>

	<ng-container *hasPermission="PermissionForStudents.QUIZ_DELETE">
	 <button class="btn outline" *ngIf="!isNewQuiz && quizStatus === CourseStatusEnum.Draft" [disabled]="isDraft"
	 (click)="openDeleteQuizDialogBox(fullQuizData.quiz_id)">Remove from draft</button>
	 </ng-container>

	 <button class="btn outline" (click)="changeQuizStatus(CourseStatusEnum.Draft)"
	 *ngIf=" isNewQuiz && quizStatus === CourseStatusEnum.Draft">
	 <ng-container *ngIf="!isDraft; else noDraft">Save as Draft</ng-container>
	 <ng-template #noDraft>
		<span class="spinner-text">
		<mat-spinner [diameter]="20"></mat-spinner>Saving...</span>
	 </ng-template>
	</button>

	<ng-container *hasPermission="PermissionForStudents.QUIZ_PUBLISH">
    <button class="btn solid" (click)="changeQuizStatus(CourseStatusEnum.Published)" [disabled]="isPublishing"
	 *ngIf="quizStatus === CourseStatusEnum.Draft">
	 <ng-container *ngIf="!isPublishing; else noPublishing">Publish Quiz</ng-container>
	 <ng-template #noPublishing>
		<span class="spinner-text">
		<mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>Publishing...</span>
	 </ng-template>
	</button>
	</ng-container>

  </div>
</div>
</ng-template>